import {Inject, Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {delay, dematerialize, materialize, mergeMap} from 'rxjs/operators';
import {mockApi} from './mock-api.constants';
import { mockErrorApi } from './mock-error-api.constants';
import {CORE_CONFIGURATION} from '../configuration';
import { environment } from 'src/environments/environment';

@Injectable()
export class FakeApiInterceptorService implements HttpInterceptor {
  constructor(@Inject(CORE_CONFIGURATION) private config) {}

  /**
   * WADG-18232: rimuove gli host noti (apiHost AEM + apiProcessFlow EKS) dalla URL,
   * cos\u00ec da poter matchare le route nei mock locali in modo uniforme.
   */
  private stripKnownHosts(url: string): string {
    let stripped = url;
    if (this.config.apiHost) {
      stripped = stripped.replace(this.config.apiHost, '');
    }
    if (environment.apiProcessFlow) {
      stripped = stripped.replace(environment.apiProcessFlow, '');
    }
    return stripped;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    if (this.config.isInEditor) {
      return of(null).pipe(
        mergeMap(() => {
          const reqUrl = this.stripKnownHosts(req.urlWithParams);

          if (
            reqUrl.startsWith('/api') ||
            reqUrl.startsWith('/ResourceInventoryManagementNg') ||
            reqUrl.startsWith('/ProductActivationManagement') ||
            reqUrl.startsWith('/productselector') ||
            reqUrl.startsWith('/geographicaddressmanagement') ||
            reqUrl.startsWith('/productactivation') ||
            reqUrl.startsWith('/activation') ||
            reqUrl.startsWith('/PrivacyManagement/v2') ||
            reqUrl.startsWith('/CustomerManagementLegacy') ||
            reqUrl.startsWith('/OneTimePassword') ||
            reqUrl.startsWith('/processflowmanagement') ||
            reqUrl.startsWith('/partymanagementlegacy')
          ) {
            const reqUrlMethod = `${req.method}:${this.stripKnownHosts(req.urlWithParams)}`;

            const serviceError = Object.keys(mockErrorApi).find((key) => new RegExp(key).test(reqUrlMethod));
            const service = Object.keys(mockApi).find((key) => new RegExp(key).test(reqUrlMethod));

            if (serviceError) {
              return of(new HttpErrorResponse({ status: 500, error: mockErrorApi[serviceError] }));
            };

            if (service) {
              return of(new HttpResponse({ status: 200, body: mockApi[service] }));
            } else {
              return throwError(new Error(`Cannot find response mock for ${reqUrl}`));
            }
          }

          return next.handle(req);
        }),
        materialize(),
        delay(1000),
        dematerialize()
      );
    }

    return next.handle(req);
  }
}
